import { Component, inject } from "@angular/core";
import { QuickLinkItemContent } from "@app/dashboard/shared/enums/QuickLinkItemContent.enum";
import { DashboardQuickLinkModel } from "@app/dashboard/shared/models/DashboardQuickLinkModel";
import { FormsDataService } from "@app/forms/services/forms-data.service";
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { BaseWidget } from "../BaseWidget";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "form-overview-widget",
    templateUrl: "../link-widget/link-widget.component.html",
    styleUrls: ["../link-widget/link-widget.component.scss"]
})
export class FormOverviewWidgetComponent extends BaseWidget {
    private _ds = inject(FormsDataService);
    private _tabService = inject(TabService);
    private _pages = inject(Pages);

    quickLinks: DashboardQuickLinkModel[];
    contentType = QuickLinkItemContent;

    async load() {
        const selectedForms = this.getFilter(this.filterKeys.Forms.FormIDs);
        this.config.noData =
            !selectedForms || !Array.isArray(selectedForms) || selectedForms.length === 0;

        if (!this.config.noData) {
            this.config.showLoader = true;
            const forms = await firstValueFrom(this._ds.getFormWidgetOverview(selectedForms));
            this.quickLinks = forms.map((f) => {
                return <DashboardQuickLinkModel>{
                    title: f.Title,
                    page: "" + f.ID,
                    imageUrl: f.ImageGuid
                        ? "api/forms/thumbnail/" + f.ImageGuid
                        : "/static/images/SimpleScreen_Editor_Image.jpg",
                    description: f.Description,
                };
            });
        }

        super.load();
    }

    openPage(formid: string) {
        if (formid.trim() === "" || isNaN(+formid)) {
            return;
        }

        this._tabService.generateTab(this._pages.FormResults, formid, "", {
            forceStartEntry: this.getFilter(this.filterKeys.Forms.LinkToNewFormEntry),
        });
    }
}
